import type { EntityRegistryEntry } from '../types';
import { getApiUserWarnings } from '../../validation/apiUserValidation';

export const apiUserConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'UserPrincipalName'],
    listColumns: () => [
        {
            key: 'userprincipalname',
            label: 'User Principal Name',
            title: 'UserPrincipalName',
            sortable: true,
            render: (entity: any) => entity.UserPrincipalName || entity.userPrincipalName || 'N/A'
        }
    ],
    getWarnings: (data) => getApiUserWarnings(data),
};
